import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon, Label } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

import Summary from './CompletedInitiative/Summary'
import Schedule from './CompletedInitiative/Schedule'
import Notes from './ActiveInitiative/Notes'
import ActivityLogs from './CompletedInitiative/ActivityLogs';
import InitiativeLogs from './CompletedInitiative/InitiativeLogs'
import NotesModal from './../Drive/modals/Notes';
import Attachments from '../../../drive/Attachments/Attachments';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class CompletedInitiative extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clickStatus: '',
            activeIndex: 0,
            // modalFlag: false
        }
    }

    notesClick = (open, clickStatus) => {
        this.setState({ open: open, clickStatus: clickStatus })
    }

    setMetadataSchemaModalFlag = (flag) => {
        this.setState({ modalFlag: flag });
    };

    render() {

        var metaDataFlag = false;
        if(this.props.selectedDataById.createdBy===this.props.user._id){
            metaDataFlag = true;
        }

        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let raci = this.props.selectedDataById.raci;

        let raciLength = raci ?
            (raci.r ? raci.r.length : 0 +
                raci.c ? raci.c.length : 0 +
                    raci.i ? raci.i.length : 0) + 1 : 0

        let counts = {}

        if (this.props.selectedDataById) {
            counts.notesLength = <Label>{this.props.selectedDataById.notes && this.props.selectedDataById.notes.length}</Label>
            counts.attachmentsLength = <Label>{this.props.selectedDataById.attachments && this.props.selectedDataById.attachments.length}</Label>
            counts.initiativeLogLength = <Label>{this.props.selectedDataById.initativeLogs && this.props.selectedDataById.initativeLogs.length}</Label>
            counts.activityLogLength = <Label>{this.props.selectedDataById.references && this.props.selectedDataById.references.length}</Label>
        }


        return (
            <div className="accordianBox w_100 ">
                <div className="accordianPanel w_100">
                    <Accordion activeIndex={this.state.activeIndex} onActivate={(activeIndex) => this.setState({ activeIndex })} expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        {[
                            <div tabTitle="Summary" key="1">
                                <div className="acc-header">Summary</div>
                                <div>
                                    <Summary {...this.props} />
                                </div>
                            </div>,
                            this.props.selectedDataById.status !== -1 ?
                                <div tabProps={{ title: 'Schedule' }} key="2">
                                    <div className="acc-header">Schedule</div>
                                    <div>
                                        <Schedule {...this.props} />
                                    </div>
                                </div> : null,
                            this.props.selectedDataById.status !== -1 ?
                                <div tabTitle={<div>Comments {counts.notesLength}</div>} key="4">

                                    <div className="acc-header">Comments {counts.notesLength}
                                        <div className="treeLabelWithCount" id='inDesign' >

                                            {this.props.selectedDataById && this.props.selectedDataById.notes && this.props.selectedDataById.notes.length ?
                                                <div className="numberCountBox" id='inDesignNo'>
                                                    {this.props.selectedDataById.notes.length}
                                                </div> : ''}
                                        </div>
                                        {(this.props.selectedDataById && this.props.selectedDataById.status === 1 || this.props.selectedDataById && this.props.selectedDataById.status === 2) &&
                                            <Icon name='plus' className="cursor-pointer" color='green' onClick={() => this.notesClick(true, "addNote")} />
                                        }
                                    </div>
                                    <div>
                                        <Notes
                                            notes={this.props.selectedDataById && this.props.selectedDataById.notes}
                                            user={this.props.user}
                                            notesClick={this.notesClick}
                                            status={this.props.selectedDataById && this.props.selectedDataById.status}
                                            selectedData={this.props.selectedDataById}
                                            string='intiativeOverview'
                                            role={this.props.selectedOrganisation.role}
                                        />

                                    </div>


                                </div> : null,

                            <div tabTitle={<div>Initiative Logs {counts.initiativeLogLength}</div>} key="5">
                                <div className="acc-header">Initiative Logs {counts.initiativeLogLength}</div>
                                <div>
                                    <InitiativeLogs
                                        user={this.props.user}
                                        selectedDataById={this.props.selectedDataById}
                                    />
                                </div>
                            </div>,
                            this.props.selectedDataById.status !== -1 ?
                                <div tabTitle={<div>Activity Logs
                                </div>} key="6">
                                    <div className="acc-header">Activity Logs
                                    </div>
                                    <div>
                                        <ActivityLogs
                                            user={this.props.user}
                                            selectedDataById={this.props.selectedDataById}
                                        />
                                    </div>
                                </div> : null,

                            <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
                                <div className="acc-header">Attachments {counts.attachmentsLength}

                                </div>
                                <div>
                                    <Attachments
                                        attachments={this.props.selectedDataById.attachments}
                                        user={this.props.user}
                                        resourceId={this.props.selectedDataById._id}
                                        entityName="initiative"
                                        initiativeStatus={this.props.selectedDataById.status}
                                        accountId={this.props.selectedDataById.accountId}
                                    />
                                </div>
                            </div>,
                            <div tabTitle="MetaData">
                            <div className="acc-header">
                                MetaData 
                            </div>
                            {this.props.selectedDataById &&
                                this.props.selectedDataById.metaData ? (
                                <div className="resourcePaneOverflow">
                                    <pre>
                                    {JSON.stringify(
                                        this.props.selectedDataById.metaData,
                                        null,
                                        2
                                    )}
                                    </pre>
                                </div>
                            ) : <span className="clr-orange">No metaData to display</span>}
                        </div>
                        ].filter(elem => !!elem)}
                    </Accordion>
                    <NotesModal notes={this.props.selectedDataById && this.props.selectedDataById.notes}
                        selectedData={this.props.selectedDataById && this.props.selectedDataById}
                        user={this.props.user}
                        open={this.state.open}
                        clickStatus={this.state.clickStatus}
                        notesClick={this.notesClick}
                        currentNote={this.props.currentNote}
                        string='intiativeOverview' />
                </div>
            </div>
        )
    }
}


export default CompletedInitiative;


